module.exports = __webpack_public_path__ + "img/szr.70cfdcbc.gif";